/**
 * Stone Investment Blog Search
 *
 * Legacy BlogSearch with Stone's minimal aesthetic:
 * square corners, stone palette, Montserrat font.
 */

'use client';

import type { BlogSearchProps } from '@routeroyal/theme-core';
import { Search } from 'lucide-react';

export function StoneBlogSearch({
  value = '',
  onChange,
  placeholder = 'Search articles...',
  className = '',
}: BlogSearchProps) {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
        <Search size={18} strokeWidth={1.5} className="text-stone-400" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
          w-full pl-12 pr-4 py-3
          border border-stone-300 bg-white/10 backdrop-blur-sm
          text-white placeholder:text-stone-400
          focus:outline-none focus:border-stone-100
          transition-colors
        "
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      />
    </div>
  );
}
